// 20.2.2.20 Math.log1p(x)
var $export = require('./_export');

$export($export.S, 'Math', { log1p: require('./_math-log1p') });



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es6.math.log1p.js
// module id = 831
// module chunks = 0